import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonModule } from "@angular/common";
import { NewJobPopoverComponent } from "./new-job-popover.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        IonicPageModule.forChild(NewJobPopoverComponent)
    ],
    declarations: [
        NewJobPopoverComponent
    ],
    exports: [
        NewJobPopoverComponent
    ],
    entryComponents: [
        NewJobPopoverComponent
    ]
})
export class NewJobPopoverModule {
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/new-job-popover/new-job-popover.module.ts